import WorkItemCommentListResultModelBase from '../_generated/modelBases/work-item-comment-list-result-model-base';

export default class WorkItemCommentListResultModel extends WorkItemCommentListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
